import styled, { css } from 'styled-components';
import { TFontWeight } from '../HBField/HBField.types';
import { fontSize } from '../HBTextField/variables';
import { vars } from '../../theme';

export interface Props {
    disabled?: boolean;
    size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    color: string;
    uppercase: boolean;
    fontWeight: string;
}

const fontWeightConverter: Record<TFontWeight, number> = {
    normal: 400,
    semibold: 600,
    bold: 700
};

export const Label = styled.label<Props>`
    font-family: ${vars.fonts.body};
    ${({ size }) => fontSize[size]}
    display: block;
    user-select: none;
    margin: 0;
    font-weight: ${({ fontWeight }) => fontWeightConverter[fontWeight]};
    color: ${({ disabled, color }) =>
        disabled ? vars.colors.text.disabled : color};

    ${({ uppercase }) =>
        uppercase &&
        css`
            text-transform: uppercase;
        `}
`;
